import type { IntercomTrigger } from '@sparklayer-io/spark-dash-core/constants/intercom';
import type { TextSize, TextVariant } from '@sparklayer-io/spark-dash-ui/components/ui/text/types';
import { TextLink } from '@ui/themed';
import type { ReactNode } from 'react';

/**
 * A text link that starts an Intercom Workflow. The Workflow matches a click on the trigger class,
 * which sits on a wrapper because TextLink takes no class name, so the link needs no handler.
 */
export function IntercomLink({
  trigger,
  size,
  variant,
  children,
}: {
  trigger: IntercomTrigger;
  size?: TextSize;
  variant?: TextVariant;
  children: ReactNode;
}) {
  return (
    <span className={trigger}>
      <TextLink size={size} variant={variant} onClick={() => {}}>
        {children}
      </TextLink>
    </span>
  );
}
